import * as yup from "yup";

export const notificationHistorySchema = yup.object().shape({
  startDate: yup.string().required("Please select start date"),
  endDate: yup.string().required("Please select end date"),
});
